import img1 from "../../assets/caseStudy/8ball.jpg";
import img2 from "../../assets/caseStudy/snoooker.jpg";
import img3 from "../../assets/caseStudy/beers.jpg";

const fakeData = [
  {
    id: 1,
    designation: "8 ball pool",
    title: "Have Fun After A Hard Day's Work",
    img: img1,
    category: "financial",
  },

  {
    id: 3,
    designation: "Drinks and snacks",
    title: "Come & Have A Cold Beer",
    img: img3,
    category: "start up",
  },
];
export default fakeData;
